import { makeStyles } from "@material-ui/core";

export const useActivityPricingStyles = makeStyles((theme) => ({
    activityText: {
        marginLeft: '0.5rem'
    },
    ectivityTextHeader: {
        fontWeight: 600
    },
    dialogWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    dialogTitle: {
        fontSize: '1.1rem',
        marginRight: '3rem'
    },
    tabs: {
        padding: '2em 0',
    },
    paper: {
        padding: '1rem 2rem',
        height: '100%',
    },
    byLotTabContent: {
        '& [class*="pageContainer"]': {
            height: '100%',
            minHeight: 'calc(100vh - 100px)',
        },
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginBottom: '1rem',
    },
    createButton: {
        height: 'fit-content',
        backgroundColor: `${theme.palette.primary.main} !important`,
        fontFamily: `${theme.typography.fontFamily} !important`,
        textTransform: 'none !important',
        '&:not(:first-child)': {
            marginLeft: '1rem',
        },
    }
}));

